import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { HomeComponent } from "./components/home/home.component";
import { HeaderComponent } from "./components/header/header.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { FooterComponent } from "./components/footer/footer.component";
import { ModalComponent } from "./components/modal/modal.component";
import { MaterialModule } from "../material/material.module";
import { ViewModule } from "../view/view.module";
import { ModalRemoveComponent } from "./components/modal-remove-active/modal-remove.component";
import { ModalLayerComponent } from "./components/modal-layer/modal-layer.component";
import { ModalCategoryComponent } from "./components/modal-category/modal-category.component";
import { AdmonActiveComponent } from "./components/modal_admon_active/admon-active/admon-active.component";
import { ModalFormsComponent } from "./components/modal-forms/modal-forms.component";
import { ModalWindowComponent } from "./components/modal-window/modal-window.component";
import { ModalWorkspaceComponent } from './components/modal-workspace/modal-workspace.component';
import { ModalAddfieldComponent } from './components/modal-addfield/modal-addfield.component';
import { LoginComponent } from './components/login/login.component';
import { FilterComponent } from './components/filter/filter.component';
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTreeModule } from '@angular/material/tree';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ModalFormUserComponent } from './components/modal-form-user/modal-form-user.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ModalNewUserComponent } from './components/modal-new-user/modal-new-user.component';
import { ConfirmDialogComponent } from "./components/confirm-dialog/confirm-dialog.component";
import { AngularSplitModule } from 'angular-split';
import { ScrollingModule } from '@angular/cdk/scrolling';



@NgModule({
    declarations: [
        HomeComponent,
        HeaderComponent,
        SidebarComponent,
        FooterComponent,
        ModalComponent,
        ModalRemoveComponent,
        ModalLayerComponent,
        ModalCategoryComponent,
        AdmonActiveComponent,
        ModalFormsComponent,
        ModalWindowComponent,
        ModalWorkspaceComponent,
        ModalAddfieldComponent,
        LoginComponent,
        FilterComponent,
        ModalFormUserComponent,
        ModalNewUserComponent,
        ConfirmDialogComponent,
    ],
    imports: [
        CommonModule,
        BrowserAnimationsModule,
        MaterialModule,
        FormsModule,
        MatIconModule,
        MatButtonModule,
        ViewModule,
        MatTableModule,
        MatPaginatorModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatSlideToggleModule,
        MatProgressBarModule,
        MatTreeModule,
        MatTooltipModule,
        MatTabsModule,
        MatCheckboxModule,
        AngularSplitModule,
        ScrollingModule
    ]
})
export class HomeModule { }
